<h4 mat-dialog-title>{{'front.nommerExpert.modale.titre' |translate}}</h4>
<mat-dialog-content style="min-height: 80px;">
  <form [formGroup]="firstFormGroup">
    <div class="form-group">
      <label for="nom">{{'general.personne.nom' |translate}}<span class="star">*</span> : </label>
      <input class="form-control" id="nom" placeholder="Nom" formControlName="nom" required>
      @if (nom.invalid && (nom.dirty || nom.touched)) {
        <div class="alert alert-danger">
          @if (nom['errors']['required']) {
            <div>
              {{'front.nommerExpert.modale.nomRequis' | translate}}.
            </div>
          }
        </div>
      }
    </div>
    <div class="form-group">
      <label for="prenom">{{'general.prenom' |translate}}<span class="star">*</span> : </label>
      <input class="form-control" id="prenom" placeholder="Prenom" formControlName="prenom" required>
      @if (prenom.invalid && (prenom.dirty || prenom.touched)) {
        <div class="alert alert-danger">
          @if (prenom['errors']['required']) {
            <div>
              {{'front.nommerExpert.modale.prenomRequis' | translate}}.
            </div>
          }
        </div>
      }
    </div>
    <div class="form-group">
      <label for="email">{{'general.email' | translate}} : </label>
      <input class="form-control" name="email" formControlName="email" id="email" type="email" placeholder="Email" required>
    </div>
    <div class="form-group">
      <label for="ville">{{'general.ville' | translate}}<span class="star">*</span> : </label>
      <input class="form-control" id="ville" placeholder="ville" formControlName="ville" required>
      @if (ville.invalid && (ville.dirty || ville.touched)) {
        <div class="alert alert-danger">
          @if (ville['errors']['required']) {
            <div>
              {{'front.nommerExpert.modale.villeRequis' | translate}}.
            </div>
          }
        </div>
      }
    </div>
    <div class="form-group">
      <label for="pays">{{'general.pays' | translate}} <span class="star">*</span> : </label>
      <mat-select class="form-control" id="pays" [compareWith]="compareByCode" formControlName="pays" required>
        @for (countrie of countries; track countrie) {
          <mat-option [value]="countrie">
            {{ countrie.label }}
          </mat-option>
        }
      </mat-select>
      @if (pays.invalid && (pays.dirty || pays.touched)) {
        <div class="alert alert-danger">
          @if (pays['errors']['required']) {
            <div>
              {{'front.nommerExpert.modale.paysRequis' | translate}}.
            </div>
          }
        </div>
      }
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="btn " [mat-dialog-close]="false" style="margin-right: 15px;">{{'general.annuler' | translate}}</button>
  <button mat-raised-button color="primary" type="submit" (click)="addExpert()">{{'front.nommerExpert.modale.envoyer' | translate}}</button>
</mat-dialog-actions>
